<!-- 存款演示 -->
<template>
    <div class="withdraw-demo">
        <div class="titleBOx">
               <h2 class="title">
                会员取款
            </h2>
        </div>
        <div class="content"> 
            <div class="box">
                <h5 class="tip4">1：绑定收款账户</h5>
                <p class="tip2">点击【个人资料】-【收款方式管理】</p>
                <p class="tip2 tip5">点击【添加银行卡】或【添加origo钱包】</p>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/withdraw1.jpg')" alt="">
                <p class="tip2">银行名称：选择开户行</p>
                <p class="tip2">支行名称：填写支行名称</p>
                <p class="tip2">银行卡号：填写收款账号</p>
                <p class="tip2">确认卡号：再次填写收款账号</p>
                <p class="tip2">验证码（非必填）：点击【发送验证码】收到我司验证码填入即可</p>
                <p class="tip2 tip5">点击【确定】：绑卡成功</p>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/withdraw2.jpg')" alt="">
                <h5 class="tip4">2：点击【资金】-【会员提款】</h5>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/withdraw3.jpg')" alt="">
                <p class="tip2">一键归集：点击，可将所有平台的余额归集到账户余额上。</p>
                <p class="tip2">收款方式：选择要用的银行卡收款</p>
                <p class="tip2">提款金额：输入要提现的额度</p>
                <p class="tip2">实际到账金额：与提款相同，如不相同则不要提交也无法出款</p>
                <p class="tip2">提现手续费：出现扣除费用则不要提交，也无法出款</p>
                <p class="tip2">行政费用：出现扣除费用则不要提交，也无法出款</p>
                <p class="tip2">优惠扣除：出现扣除费用则不要提交，也无法出款</p>
                <p class="tip2 tip5">交易密码：输入交易密码，点击确定即可。</p>
                <img loading="lazy" v-lazy="require('../../assets/images/yy/withdraw4.jpg')" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            index:0
        }
    },
     computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .withdraw-demo{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .box{
                width: 100%;
                .list{
                    display: inline-block;
                    width: 116px;
                    height: 42px;
                    background: #d9d9d9;
                    color: #000;
                    line-height: 45px;
                    font-size: 14px;
                    overflow: hidden;
                    margin-bottom: 30px;
                    margin-top: 10px;
                    margin-right: 10px;
                    font-weight: 600;
                    cursor: pointer;
                    text-indent: 0;
                    text-align: center;
                }
                .activity{
                    background: #000;
                    color: #fff;
                }
                img{
                    width: 100%;
                    margin-bottom: 10px;
                }
                .tip4 {
                    font-size: 15px;
                    padding: 0 0 10px;
                }
                .tip2 {
                    line-height: 28px;
                    font-size: 14px;
                    color: #666;
                }
                .tip5 {
                    margin-bottom: 20px;
                }
            }
        }
    }
</style>